export const PATERNITY_STUDIES_ACTIONS = {
    GET: 'PATERNITY_STUDIES_GET',
    GET_SHEET: 'PATERNITY_STUDIES_GET_SHEET',
    GET_CALCULATION: 'PATERNITY_STUDIES_GET_CALCULATION',
    GET_INBOX: 'PATERNITY_STUDIES_GET_INBOX',
    GET_OUTBOX: 'PATERNITY_STUDIES_GET_OUTBOX',

    FIND: 'PATERNITY_STUDIES_FIND',
    FIND_INDIVIDUALS: 'PATERNITY_STUDIES_FIND_INDIVIDUALS',
    FIND_SAMPLES: 'PATERNITY_STUDIES_FIND_SAMPLES',
    FIND_ATTACHMENTS: 'PATERNITY_STUDIES_FIND_ATTACHMENTS',

    TRACEABILITY: 'PATERNITY_STUDIES_TRACEABILITY',
    RESET: 'PATERNITY_STUDIES_RESET',
    CLEAN: 'PATERNITY_STUDIES_CLEAN',
    UPDATE: 'PATERNITY_STUDIES_UPDATE',
    SUCCESS: 'PATERNITY_STUDIES_SUCCESS',
    ERROR: 'PATERNITY_STUDIES_ERROR',
    SUCCESS_UPLOAD_FILE: 'PATERNITY_STUDIES_SUCCESS_UPLOAD_FILE',
    CLEAN_IMPORTS: 'PATERNITY_STUDIES_CLEAN_IMPORTS',
    CLEAN_CALCULATION: 'PATERNITY_STUDIES_CLEAN_CALCULATION',

    GET_TYPES: 'PATERNITY_STUDIES_GET_TYPES',
}